class CartUpsellManager {
  constructor() {
    this.cartItemsElement = document.querySelector('cart-items');
    if (!this.cartItemsElement) return;

    document.addEventListener('click', (event) => {
      const button = event.target.closest('.cart-upsell__add');
      if (!button) return;
      const context = button.dataset.upsellContext || 'cart';
      if (context !== 'cart') return;
      event.preventDefault();
      this.addVariantToCart(button);
    });
  }

  addVariantToCart(button) {
    if (button.classList.contains('is-loading')) return;

    const variantId = Number(button.dataset.upsellVariant);
    if (!variantId) return;

    button.classList.add('is-loading');
    button.setAttribute('disabled', true);

    const sectionsToRender = this.getSectionsToRender();
    const body = JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: sectionsToRender.map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((state) => {
        this.renderSections(state, sectionsToRender);
      })
      .catch(() => {})
      .finally(() => {
        button.classList.remove('is-loading');
        button.removeAttribute('disabled');
      });
  }

  getSectionsToRender() {
    const sections = [];
    const mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems) {
      sections.push({
        id: 'main-cart-items',
        section: mainCartItems.dataset.id,
        selector: '.js-contents'
      });
    }

    const mainCartFooter = document.getElementById('main-cart-footer');
    if (mainCartFooter) {
      sections.push({
        id: 'main-cart-footer',
        section: mainCartFooter.dataset.id,
        selector: '.js-contents'
      });
    }

    sections.push({
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    });

    return sections;
  }

  renderSections(state, sectionsToRender) {
    if (!state || !state.sections) return;
    sectionsToRender.forEach((section => {
      const element = document.getElementById(section.id);
      if (!element) return;

      const source = state.sections[section.section];
      if (!source) return;

      const html = this.getSectionInnerHTML(source, section.selector);
      const target = element.querySelector(section.selector) || element;
      target.innerHTML = html;
    }));
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const fragment = doc.querySelector(selector);
    return fragment ? fragment.innerHTML : doc.body.innerHTML;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CartUpsellManager();
});
